(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.chapterCarousel = {
    attach: function (context, settings) {
      // Prevent outer component from being initialized as slick
      $('.chapter-carousel-component', context).once('prevent-component-slick').each(function() {
        const $component = $(this);
        // If the component itself was initialized as slick, destroy it
        if ($component.hasClass('slick-initialized')) {
          try {
            $component.slick('unslick');
          } catch (e) {
            // If unslick fails, remove slick classes manually
            $component.removeClass('slick-initialized slick-slider');
            $component.find('.slick-list, .slick-track').remove();
          }
        }
      });

      // Only target .chapter-carousel inside .chapter-carousel-component to avoid double initialization
      $('.chapter-carousel-component .chapter-carousel', context).once('chapter-carousel').each(function() {
        const $carousel = $(this);
        
        // Make sure this element isn't already initialized as slick
        if ($carousel.hasClass('slick-initialized')) {
          return;
        }
        
        const slideCount = $carousel.find('.carousel-items').length;
        
        // Only initialize if there are items
        if (slideCount === 0) return;

        const slickOptions = {
          accessibility: true,
          focusOnChange: false,
          focusOnSelect: false,
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          slide: '.carousel-items', // Only target .carousel-items as slides, not other children like star container
          nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide"></button>',
          prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide"></button>',
          responsive: [
            {
              breakpoint: 1024,
              infinite: true,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                focusOnChange: false,
                focusOnSelect: false
              }
            },
            {
              breakpoint: 768,
              infinite: true,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                focusOnChange: false,
                focusOnSelect: false
              }
            }
          ]
        };

        $carousel.slick(slickOptions);

        // Add accessibility attributes to slides
        $carousel.on('afterChange', function(event, slick, currentSlide) {
          updateSlideAccessibility($carousel);
        });

        //on resize, update the carousel
        $(window).on('resize', function() {
          $carousel.slick('refresh');
        });

        // Initial accessibility setup
        updateSlideAccessibility($carousel);

        function updateSlideAccessibility($slider) {
          const inactiveOptions = { 'tabindex': '-1', 'aria-hidden': 'true' };
          const activeOptions = { 'tabindex': '0', 'aria-hidden': 'false' };

          $slider.find('.slick-slide').not('.slick-active').find('a, button, [tabindex]').attr(inactiveOptions);
          $slider.find('.slick-slide.slick-active').find('a, button, [tabindex]').attr(activeOptions);
        }
      });

      // Audio language toggle functionality
      $('.chapter-carousel-component', context).once('audio-language-toggle').each(function() {
        const $component = $(this);
        
        $component.on('click', '.audio-language-toggle', function(e) {
          e.preventDefault();
          const $toggle = $(this);
          const $snippet = $toggle.closest('.chapter-carousel-audio-snippet');
          const $audioElements = $snippet.find('audio');
          const $iconEn = $toggle.find('.icon-en');
          const $iconEs = $toggle.find('.icon-es');
          const currentLang = $toggle.data('current-lang');
          
          // Find currently visible audio
          const $currentAudio = $audioElements.filter('[data-lang="' + currentLang + '"]');
          
          // Pause current audio if playing
          if ($currentAudio.length && $currentAudio[0]) {
            $currentAudio[0].pause();
          }
          
          // Toggle to the other language
          if (currentLang === 'en') {
            // Switch to Spanish
            const $spanishAudio = $audioElements.filter('[data-lang="es"]');
            if ($spanishAudio.length) {
              $currentAudio.hide();
              $spanishAudio.show();
              $iconEn.hide();
              $iconEs.show();
              $toggle.data('current-lang', 'es');
            }
          } else {
            // Switch to English
            const $englishAudio = $audioElements.filter('[data-lang="en"]');
            if ($englishAudio.length) {
              $currentAudio.hide();
              $englishAudio.show();
              $iconEs.hide();
              $iconEn.show();
              $toggle.data('current-lang', 'en');
            }
          }
        });
      });
    }
  };

})(jQuery, Drupal);

